import * as React from 'react';
import cn from 'classnames';
import Paper from '@mui/material/Paper';
import { useTheme } from '../../../theme';
const RefundPaper = props => {
    const { RefundPaper: css } = useTheme('Refund');
    return (React.createElement(Paper, Object.assign({ elevation: 0, square: true }, props, { className: cn(css.paper, props.className) }), props.children));
};
export default RefundPaper;
